import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import {
  InfoOutlined,
  BuildOutlined,
  LocalFireDepartmentOutlined,
  FactoryOutlined,
  VisibilityOutlined,
  AssignmentOutlined,
  RecyclingOutlined,
  Inventory2Outlined,
} from "@mui/icons-material";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useSelector } from "react-redux";
import { translateText } from "../../translations/translationService";
import { BRAND_COLORS, BACKGROUND_COLORS, STATUS_COLORS } from "../../style/colors.js";

const LeftCargaFabrica = ({ onTeamSelect }) => {
  const lang = useSelector((state) => state.lang.value);
  const [activeButton, setActiveButton] = useState("Información");

  const buttonConfig = {
    Información: {
      icon: InfoOutlined,
      color: BRAND_COLORS.ACCENT,
    },
    Reparaciones: {
      icon: BuildOutlined,
      color: BRAND_COLORS.ACCENT,
    },
    "Estado Fundición": {
      icon: LocalFireDepartmentOutlined,
      color: BRAND_COLORS.ACCENT,
    },
    "Estado Metales": {
      icon: MaterialCommunityIcons,
      iconName: "gold",
      color: BRAND_COLORS.ACCENT,
    },
    Fornituras: {
      icon: Inventory2Outlined,
      color: BRAND_COLORS.ACCENT,
    },
    "Carga de Fabrica": {
      icon: FactoryOutlined,
      color: BRAND_COLORS.ACCENT,
    },
    Detalle: {
      icon: VisibilityOutlined,
      color: BRAND_COLORS.ACCENT,
    },
    Asignaciones: {
      icon: AssignmentOutlined,
      color: BRAND_COLORS.ACCENT,
    },
    "Rec. de Merma": {
      icon: RecyclingOutlined,
      color: BRAND_COLORS.ACCENT,
    },
  };

  const uniqueTeams = [
    "Información",
    "Reparaciones",
    "Estado Fundición",
    "Estado Metales",
    "Fornituras",
    "Carga de Fabrica",
    "Detalle",
    "Asignaciones",
    "Rec. de Merma",
  ];

  const handlePress = (item) => {
    setActiveButton(item);
    onTeamSelect(item);
  };

  return (
    <View style={styles.container}>
      {uniqueTeams.map((item) => {
        const config = buttonConfig[item];
        const IconComponent = config?.icon;
        const isActive = activeButton === item;

        return (
          <TouchableOpacity key={item} onPress={() => handlePress(item)}>
            <View
              style={[
                styles.item,
                isActive ? styles.itemActive : styles.itemInactive,
                isActive && {
                  backgroundColor: config?.color || BRAND_COLORS.PRIMARY_LIGHT,
                  borderColor: config?.color || BRAND_COLORS.PRIMARY_LIGHT,
                },
              ]}>
              {isActive && <View style={styles.gradientOverlay} />}

              <View style={styles.contentContainer}>
                {/* Icono */}
                {IconComponent && (
                  <View
                    style={[
                      styles.iconContainer,
                      isActive
                        ? styles.iconContainerActive
                        : styles.iconContainerInactive,
                    ]}>
                    {config?.iconName ? (
                      <IconComponent
                        name={config.iconName}
                        size={22}
                        color={isActive ? "white" : "#174045"}
                      />
                    ) : (
                      <IconComponent
                        style={{
                          fontSize: 22,
                          color: isActive ? "white" : "#174045",
                        }}
                      />
                    )}
                  </View>
                )}

                <Text
                  style={[
                    styles.teamName,
                    isActive ? styles.teamNameActive : styles.teamNameInactive,
                  ]}>
                  {translateText(item, lang)}
                </Text>

                {isActive && <View style={styles.activeIndicator} />}
              </View>
            </View>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const { width } = Dimensions.get("window");

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 8,
    marginVertical: 4,
    backgroundColor: "#f5f5f5",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
    paddingVertical: 4,
    paddingHorizontal: 4,
  },

  item: {
    paddingVertical: 6,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 4,
    paddingHorizontal: 10,
    marginVertical: 3,
    flexBasis: "30%",
    width: 140,
    minHeight: 65,
    borderWidth: 1,
    position: "relative",
    overflow: "hidden",
  },

  itemInactive: {
    backgroundColor: "#ffffff",
    borderColor: "rgba(0, 0, 0, 0.08)",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.03,
    shadowRadius: 2,
    elevation: 1,
  },

  itemActive: {
    backgroundColor: "#7aa5b3",
    borderColor: "#7aa5b3",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },

  gradientOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "30%",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },

  contentContainer: {
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    zIndex: 1,
  },

  iconContainerInactive: {
    marginBottom: 4,
    backgroundColor: "transparent",
    borderRadius: 4,
    padding: 4,
    borderWidth: 0,
  },

  iconContainerActive: {
    marginBottom: 4,
    backgroundColor: "transparent",
    borderRadius: 4,
    padding: 4,
    borderWidth: 0,
  },

  teamNameInactive: {
    color: "#174045",
    fontWeight: "500",
    fontSize: 12,
    textAlign: "center",
    flexShrink: 1,
  },

  teamNameActive: {
    color: "#ffffff",
    fontWeight: "500",
    fontSize: 12,
    textAlign: "center",
    flexShrink: 1,
  },

  activeIndicator: {
    position: "absolute",
    top: 4,
    right: 4,
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: "#4ade80",
    borderWidth: 1.5,
    borderColor: "#ffffff",
  },
});

export default LeftCargaFabrica;
